{
  "actionModals": {
    "assign": {
      "aria": "Gán vendor",
      "overrideScore": "Ghi đè điểm thắng cuộc (admin ép chọn)",
      "reasonLabel": "Lý do (≥ 10 ký tự)*",
      "submit": "Gán vendor",
      "submitting": "Đang gán…",
      "subtitle": "Gán hoặc đổi vendor cho đơn. Lý do tối thiểu 10 ký tự — sẽ ghi nhật ký kiểm toán.",
      "title": "Gán / Gán lại vendor",
      "toastError": "Gán vendor thất bại",
      "toastSuccess": "Đã gán vendor",
      "vendorLabel": "Vendor*",
      "vendorPlaceholder": "Chọn vendor…"
    },
    "cancel": {
      "aria": "Hủy đơn hàng",
      "cancelAllItems": "hủy toàn bộ mục",
      "compAmountLabel": "Bồi thường (USD)*",
      "compEnable": "Phát bồi thường cho vendor",
      "compLegend": "Bồi thường vendor",
      "compReasonLabel": "Lý do bồi thường*",
      "irreversibleAck": "Tôi xác nhận hiểu rằng hành động này là vĩnh viễn.",
      "irreversibleBody": "Khi đơn đã chuyển sang trạng thái đã hủy, hệ thống không có đường khôi phục — nếu cần xử lý lại, merchant phải tạo đơn mới (ngoài luồng hủy + hoàn tiền này). Hãy chắc rằng đã chọn đúng chế độ (mềm / ép), đúng các mục (hoặc toàn bộ đơn), và chính sách hoàn tiền đã khớp với thỏa thuận với merchant.",
      "irreversibleTitle": "Thao tác không thể hoàn tác.",
      "itemMeta": "SL {{qty}} · {{status}}",
      "itemsLegend": "Các mục cần hủy (để trống = toàn bộ)",
      "modeForce": "Ép hủy",
      "modeSoft": "Hủy mềm (chỉ các mục hủy được)",
      "notifyMerchant": "Thông báo merchant (email)",
      "reasonCodeLabel": "Mã lý do*",
      "reasonTextLabel": "Nội dung lý do (≥ 10 ký tự)*",
      "refundAmountLabel": "Số tiền hoàn (USD)*",
      "refundPolicyLegend": "Chính sách hoàn tiền",
      "refundPolicyOptions": {
        "full": "toàn bộ",
        "none": "không",
        "partial": "một phần"
      },
      "selectAll": "Chọn tất cả ({{count}})",
      "selectedCount": "{{selected}}/{{total}} đã chọn",
      "submit": "Hủy đơn (vĩnh viễn)",
      "subtitle": "Hủy đơn kèm hoàn tiền + bồi thường vendor. Hoàn tiền > $500 hoặc ép hủy đơn > $1000 → duyệt kép.",
      "title": "Hủy đơn",
      "toastDualApprovalDesc": "Ngưỡng — chờ người duyệt thứ 2 phê duyệt (id {{id}}).",
      "toastDualApprovalTitle": "Đã chuyển sang duyệt kép",
      "toastError": "Hủy đơn thất bại",
      "toastSuccess": "Đã hủy đơn"
    },
    "common": {
      "cancel": "Hủy",
      "centsLine": "= {{cents}} cents",
      "clear": "Xóa",
      "processing": "Đang xử lý…"
    },
    "reasonCodes": {
      "CHANGED_MIND": "Đổi ý",
      "CUSTOMER_REQUEST": "Khách yêu cầu",
      "DUPLICATE_ORDER": "Đơn trùng lặp",
      "FRAUD_SUSPECTED": "Nghi ngờ gian lận",
      "OTHER": "Khác",
      "POLICY_VIOLATION": "Vi phạm chính sách",
      "SYSTEM_ERROR": "Lỗi hệ thống",
      "VENDOR_FAILURE": "Vendor thất bại",
      "WRONG_ADDRESS": "Sai địa chỉ",
      "WRONG_ARTWORK": "Sai thiết kế",
      "WRONG_PRODUCT": "Sai sản phẩm"
    },
    "refund": {
      "amountLabel": "Số tiền hoàn (USD)*",
      "aria": "Hoàn tiền đơn hàng",
      "centsLine": "= {{cents}} cents · {{mode}}",
      "fullButton": "Toàn bộ (${{amount}})",
      "modeFull": "hoàn toàn bộ",
      "modePartial": "một phần",
      "noteLabel": "Ghi chú",
      "reasonCodeLabel": "Mã lý do*",
      "submit": "Hoàn tiền",
      "subtitle": "Tạo hoàn tiền. Hoàn tiền > $500 sẽ chuyển sang duyệt kép.",
      "title": "Hoàn tiền",
      "toastError": "Hoàn tiền thất bại",
      "toastSuccess": "Đã gửi yêu cầu hoàn tiền"
    },
    "resend": {
      "aria": "In lại đơn hàng",
      "costLabel": "Trách nhiệm chi phí*",
      "costOptions": {
        "platform": "nền tảng (0/100)",
        "shared": "chia sẻ (50/50)",
        "vendor": "vendor (100/0)"
      },
      "reasonLabel": "Lý do (≥ 10 ký tự)*",
      "submit": "In lại",
      "subtitle": "Tạo lệnh in lại cho đơn. Trách nhiệm chi phí quyết định ai chịu phí.",
      "title": "In lại / Phát hành lại",
      "toastError": "In lại thất bại",
      "toastSuccess": "Đã tạo lệnh in lại",
      "vendorLabel": "Vendor (để trống = giữ vendor gốc)",
      "vendorPlaceholder": "(ghi đè tùy chọn)"
    },
    "surcharge": {
      "amountLabel": "Số tiền phụ phí (USD)*",
      "aria": "Thêm phụ phí",
      "paymentMethodLabel": "Phương thức thanh toán (tùy chọn)",
      "paymentOptions": {
        "credit": "tín dụng",
        "default": "(dùng mặc định)",
        "wallet": "ví"
      },
      "reasonLabel": "Lý do (≥ 10 ký tự)*",
      "submit": "Thêm phụ phí",
      "subtitle": "Tạo phụ phí gắn vào đơn. Lý do tối thiểu 10 ký tự.",
      "title": "Thêm phụ phí",
      "toastError": "Thêm phụ phí thất bại",
      "toastSuccess": "Đã thêm phụ phí"
    }
  },
  "admin": {
    "sendOnBehalf": {
      "section": {
        "title": "Gửi sản xuất (admin)",
        "description": "Duyệt và gửi đơn đang chờ này sang sản xuất thay cho merchant."
      },
      "button": "Gửi sản xuất (thay merchant)",
      "submitting": "Đang gửi…",
      "confirm": {
        "title": "Gửi sản xuất thay merchant?",
        "body": "Thao tác này duyệt đơn và chuyển sang sản xuất thay cho merchant. Merchant sẽ được thông báo. Tiếp tục?",
        "confirmLabel": "Gửi sản xuất",
        "cancelLabel": "Hủy"
      },
      "success": "Đã gửi đơn sang sản xuất thay cho merchant.",
      "successDesc": "Đã phân bổ {{count}} mục vào sản xuất.",
      "error": "Không thể gửi đơn sang sản xuất.",
      "errorInvalidState": "Đơn này không còn ở trạng thái chờ phê duyệt.",
      "errorNotFound": "Không tìm thấy đơn hàng.",
      "blocked": {
        "title": "Artwork chưa được xác thực",
        "body": "Một hoặc nhiều mục bị chặn do artwork chưa được xác thực. Hãy xử lý trước khi gửi sản xuất.",
        "areasLabel": "Vùng bị chặn:",
        "areaItem": "Vùng {{area}} — {{status}}"
      }
    }
  },
  "chips": {
    "aria": "Bộ lọc phụ sự cố",
    "clear": "Xóa lọc",
    "descriptions": {
      "dlq_failed": "Tiến trình nền rơi vào hàng đợi lỗi (dead-letter queue).",
      "mapping_error": "Thiếu hoặc lỗi thời ánh xạ SKU / năng lực vendor.",
      "quality_issue": "Sản xuất không đạt khi vendor kiểm tra chất lượng.",
      "shipping_problem": "Đơn vị vận chuyển báo ngoại lệ / kiện hàng lỗi."
    },
    "statusLabels": {
      "dlq_failed": "Lỗi DLQ",
      "mapping_error": "Lỗi ánh xạ",
      "quality_issue": "Vấn đề chất lượng",
      "shipping_problem": "Sự cố vận chuyển"
    },
    "subFilter": "Bộ lọc phụ"
  },
  "csvImport": {
    "columns": {
      "error": "Lỗi",
      "status": "Trạng thái"
    },
    "page": {
      "description": "Tải lên file CSV để gán lại Vendor cho nhiều đơn hàng cùng lúc. Quy trình 2 bước: xem trước → xác nhận áp dụng (all-or-none).",
      "heading": "Nhập CSV gán lại Vendor",
      "reasonHint": "tối thiểu 20 ký tự.",
      "requiredColumnsLabel": "Cột bắt buộc:"
    },
    "status": {
      "INVALID": "Lỗi",
      "OK": "OK",
      "SKIP-cancelled": "Bỏ qua (đã huỷ)",
      "SKIP-shipped": "Bỏ qua (đã giao)"
    },
    "step1": {
      "downloadTemplate": "Tải template CSV",
      "heading": "Bước 1 — Tải lên file CSV",
      "preview": "Xem trước",
      "previewing": "Đang xem trước…",
      "selectedPrefix": "Đã chọn:"
    },
    "step2": {
      "applyConfirm": "Xác nhận áp dụng ({{count}})",
      "applying": "Đang áp dụng…",
      "downloadErrors": "Tải báo cáo lỗi (.csv)",
      "heading": "Bước 2 — Xem trước kết quả",
      "invalidLabel": "Lỗi:",
      "moreRows": "Đã hiển thị {{shown}} / {{total}} dòng. Tải báo cáo lỗi để xem toàn bộ chi tiết.",
      "skipLabel": "Bỏ qua:",
      "totalLabel": "Tổng:",
      "validLabel": "Hợp lệ:"
    },
    "toast": {
      "applyFailTitle": "Áp dụng thất bại",
      "applySuccessDesc": "Đã gán lại Vendor cho {{count}} đơn hàng.",
      "applySuccessTitle": "Áp dụng thành công",
      "emptyFileDesc": "Hãy chọn file CSV có ít nhất 1 dòng dữ liệu.",
      "emptyFileTitle": "File rỗng",
      "invalidResponseDesc": "Server trả về dữ liệu xem trước không hợp lệ.",
      "invalidResponseTitle": "Phản hồi không hợp lệ",
      "networkErrorDesc": "Không thể kết nối tới máy chủ",
      "networkErrorTitle": "Lỗi mạng",
      "noFileDesc": "Hãy chọn file CSV trước khi xem trước.",
      "noFileTitle": "Chưa chọn file",
      "noValidRowsDesc": "Hãy sửa lỗi rồi tải lại CSV.",
      "noValidRowsTitle": "Không có dòng nào hợp lệ",
      "previewReadyDesc": "{{valid}}/{{total}} dòng hợp lệ. Hết hạn sau {{minutes}} phút.",
      "previewReadyTitle": "Xem trước sẵn sàng",
      "tooLargeDesc": "Kích thước tối đa 5 MB. File hiện tại {{size}} MB.",
      "tooLargeTitle": "File quá lớn",
      "unknownError": "Lỗi không xác định",
      "uploadFailTitle": "Tải lên thất bại",
      "wrongFormatDesc": "Vui lòng chọn file .csv",
      "wrongFormatTitle": "Sai định dạng"
    }
  },
  "detail": {
    "back": "Quay lại Đơn hàng",
    "badRoute": {
      "body": "Vui lòng quay lại danh sách đơn hàng.",
      "title": "Đơn hàng không hợp lệ"
    },
    "loadError": "Không thể tải chi tiết đơn hàng.",
    "loading": "Đang tải đơn hàng…",
    "tabs": {
      "finance": "Tài chính",
      "history": "Lịch sử & Hỗ trợ",
      "overview": "Tổng quan",
      "sectionsAria": "Các mục chi tiết đơn hàng",
      "shipping": "Vận chuyển"
    },
    "vendorOverride": {
      "button": "Đổi nhà cung cấp",
      "description": "Đổi nhà cung cấp cho đơn này. Chỉ chuyển quyền sở hữu — KHÔNG kích hoạt phê duyệt lại.",
      "title": "Ghi đè nhà cung cấp (admin)"
    }
  },
  "header": {
    "grandTotalLabel": "Tổng đơn",
    "statusLabels": {
      "accepted": "Đã tiếp nhận",
      "assigned": "Đã phân công",
      "attention_required": "Cần chú ý",
      "cancelled": "Đã hủy",
      "confirmed": "Đã xác nhận",
      "delivered": "Đã giao",
      "draft": "Nháp",
      "in_production": "Đang sản xuất",
      "on_hold": "Tạm giữ",
      "partially_cancelled": "Hủy một phần",
      "partially_shipped": "Giao vận một phần",
      "pending_emb_payment": "Chờ thanh toán thêu",
      "pending_payment": "Chờ thanh toán",
      "pending_reassignment": "Chờ phân công lại",
      "quality_check": "Kiểm tra chất lượng",
      "ready_to_ship": "Sẵn sàng giao",
      "returned_partial": "Trả hàng một phần",
      "shipped": "Đã giao vận",
      "unknown": "Không rõ"
    },
    "copyBarcode": "Sao chép barcode",
    "actions": {
      "assign": "Gán",
      "reassign": "Gán lại",
      "refund": "Hoàn tiền",
      "resend": "Gửi lại",
      "cancel": "Hủy đơn",
      "surcharge": "Thêm phụ phí"
    }
  },
  "leftColumn": {
    "adminNotes": {
      "empty": "Chưa có ghi chú nào.",
      "heading": "Ghi chú nội bộ",
      "loading": "Đang tải…",
      "placeholder": "Ghi chú nội bộ — chỉ admin nhìn thấy.",
      "save": "Lưu",
      "saveFailed": "Lưu ghi chú thất bại",
      "readOnly": "Bạn không có quyền thêm ghi chú nội bộ — chỉ xem được các ghi chú đã có."
    },
    "compensationHistory": {
      "empty": "Chưa có bồi thường nào.",
      "heading": "Lịch sử bồi thường",
      "loading": "Đang tải…"
    },
    "deliveryAddress": {
      "adjustedBadge": "Đã điều chỉnh",
      "diffTitle": "Khách gửi → Chuẩn hoá",
      "heading": "Địa chỉ giao hàng",
      "noAddress": "Đơn chưa có địa chỉ giao hàng."
    },
    "items": {
      "artworkAlt": "Artwork {{num}}",
      "artworkCount": "{{count}} file",
      "artworkLabelFallback": "Artwork",
      "artworkNone": "Chưa có",
      "columns": {
        "artwork": "Artwork",
        "cogs": "COGS",
        "embroidery": "Thêu",
        "price": "Giá",
        "product": "Sản phẩm",
        "quantity": "SL",
        "shippingFee": "Phí vận chuyển",
        "sku": "SKU",
        "status": "Trạng thái",
        "total": "Tổng",
        "unitPrice": "Đơn giá",
        "vendor": "Vendor"
      },
      "download": "Tải artwork",
      "empty": "Đơn này chưa có item nào.",
      "expandHint": "Bấm 1 dòng để xem artwork",
      "heading": "Mặt hàng ({{count}})",
      "lineTotal": "Thành tiền",
      "noArtworkUpload": "Item này chưa có artwork upload.",
      "thumbnailNa": "N/A",
      "unknownProduct": "Sản phẩm không xác định",
      "vendorFallback": "Vendor #{{id}}",
      "vendorUnassigned": "Chưa gán",
      "totals": {
        "subtotal": "Tạm tính",
        "embroidery": "Phí thêu",
        "shipping": "Phí vận chuyển",
        "surcharge": "Phụ phí",
        "tax": "Thuế",
        "grandTotal": "Tổng cộng"
      }
    },
    "orderInfo": {
      "heading": "Thông tin đơn",
      "labels": {
        "createdAt": "Tạo lúc",
        "orderId": "Mã đơn",
        "orderNumber": "Số đơn",
        "payment": "Thanh toán",
        "status": "Trạng thái",
        "updatedAt": "Cập nhật lúc"
      }
    },
    "refundHistory": {
      "backendPending": "Tính năng hoàn tiền chưa sẵn sàng — sẽ khả dụng khi hệ thống hoàn tiền được triển khai.",
      "empty": "Chưa có yêu cầu hoàn tiền nào.",
      "heading": "Lịch sử hoàn tiền",
      "loading": "Đang tải…",
      "statusLabels": {
        "approved": "Đã duyệt",
        "failed": "Thất bại",
        "pending": "Chờ xử lý",
        "rejected": "Đã từ chối",
        "settled": "Đã hoàn tất"
      }
    },
    "relatedTickets": {
      "empty": "Chưa có ticket nào liên kết — module hỗ trợ chưa được triển khai.",
      "heading": "Ticket liên quan",
      "loading": "Đang tải…"
    },
    "shippingTracking": {
      "empty": "Chưa có shipment.",
      "errorHint": "Thông tin tracking sẽ khả dụng khi vendor xác nhận shipment.",
      "heading": "Vận chuyển & Tracking",
      "loading": "Đang tải…"
    },
    "surchargeHistory": {
      "empty": "Chưa có phụ phí.",
      "heading": "Lịch sử phụ phí",
      "loading": "Đang tải…"
    },
    "timeline": {
      "empty": "Chưa có sự kiện.",
      "heading": "Dòng thời gian",
      "loading": "Đang tải…"
    }
  },
  "list": {
    "sub": {
      "unit": "Đơn giá",
      "shipping": "Vận chuyển",
      "total": "Tổng",
      "artworkOk": "Có artwork",
      "artworkNone": "Thiếu artwork"
    },
    "actions": {
      "openOrderAria": "Mở đơn {{orderNumber}}",
      "openOrderTitle": "Mở chi tiết đơn hàng"
    },
    "bulk": {
      "approvalCount": "{{count}} chờ duyệt",
      "approvalDesc": "Lô đã tạm giữ. Mã yêu cầu {{requestId}}; {{count}} đơn vượt ngưỡng {{threshold}}.",
      "approvalTitle": "Cần phê duyệt kép",
      "exportQueuedDesc": "Tác vụ xuất {{jobId}} đã vào hàng đợi cho {{count}} đơn ({{format}}).",
      "exportQueuedTitle": "Đã đưa xuất file vào hàng đợi",
      "failedCount": "{{count}} thất bại",
      "failedTitle": "Thao tác hàng loạt thất bại",
      "noneAffected": "Không có đơn hàng nào bị ảnh hưởng.",
      "noneSelectedDesc": "Chọn ít nhất một đơn để chạy thao tác hàng loạt này.",
      "noneSelectedTitle": "Chưa chọn đơn hàng",
      "okCount": "{{count}} đã áp dụng",
      "queuedCount": "{{count}} đã đưa vào hàng đợi",
      "reassignNoneSelectedDesc": "Chọn ít nhất một đơn để phân công lại vendor hàng loạt.",
      "skippedDesc": "{{count}} đơn đã chọn không hợp lệ cho thao tác này (trạng thái) — đã bỏ qua",
      "skippedTitle": "Một số đơn bị bỏ qua",
      "submittedTitle": "Đã gửi thao tác hàng loạt",
      "ineligibleVendorChange": "Không đơn nào trong số đã chọn đổi được vendor — đơn đã gửi, đã giao, đã hủy và đã trả hàng bị khóa.",
      "ineligibleCancel": "Không đơn nào trong số đã chọn hủy được — đơn đã gửi, đã giao, đã hủy và đã trả hàng bị khóa.",
      "ineligibleResend": "Gửi lại chỉ áp dụng cho đơn đã giao hoặc trả hàng một phần."
    },
    "bulkActions": {
      "assign": "Gán Vendor",
      "cancel": "Hủy",
      "export": "Xuất CSV",
      "reassign": "Phân công lại Vendor hàng loạt",
      "refund": "Hoàn tiền",
      "resend": "Gửi lại"
    },
    "columns": {
      "approved": "Đã duyệt",
      "items": "Số mục",
      "lastUpdated": "Cập nhật gần nhất",
      "orderId": "Mã đơn",
      "received": "Tiếp nhận",
      "source": "Nguồn",
      "status": "Trạng thái",
      "store": "Cửa hàng",
      "surcharge": "Phụ phí",
      "total": "Tổng",
      "tracking": "Mã vận đơn",
      "vendor": "Nhà cung cấp",
      "product": "Sản phẩm",
      "platform": "Nền tảng",
      "orderType": "Loại đơn",
      "merchantEmail": "Email merchant",
      "sla": "SLA",
      "resetColumns": "Đặt lại cột",
      "saveFailedTitle": "Không thể lưu bố cục cột",
      "actions": "Thao tác"
    },
    "filters": {
      "search": {
        "label": "Tìm kiếm",
        "placeholder": "Số đơn, ID, mã vận đơn…"
      },
      "source": {
        "label": "Nguồn"
      },
      "status": {
        "label": "Trạng thái"
      },
      "store": {
        "label": "Cửa hàng",
        "placeholder": "Tất cả cửa hàng"
      },
      "payment": {
        "label": "Trạng thái thanh toán",
        "placeholder": "Tất cả trạng thái thanh toán"
      },
      "artwork": {
        "label": "Trạng thái artwork",
        "placeholder": "Tất cả trạng thái artwork"
      },
      "product": {
        "label": "Sản phẩm",
        "placeholder": "Tìm sản phẩm…"
      }
    },
    "unassigned": "Chưa gán",
    "empty": "Không có đơn hàng nào khớp bộ lọc.",
    "errors": {
      "network": "Lỗi mạng — kiểm tra kết nối"
    },
    "manualAssign": "Phân công thủ công",
    "page": {
      "heading": "Đơn hàng",
      "subtitle": "Danh sách đơn hàng toàn merchant. Thao tác hàng loạt khi chọn nhiều chỉ áp dụng cho trang hiện tại."
    },
    "prompts": {
      "cancelReason": "Lý do hủy:",
      "refundReason": "Lý do hoàn tiền:",
      "resendReason": "Lý do gửi lại:",
      "saveView": "Lưu bộ lọc hiện tại thành chế độ xem có tên:",
      "vendorId": "Vendor ID (24 ký tự hex):"
    },
    "reasonCategories": {
      "capacity_overflow": "Quá tải công suất",
      "manual_reroute": "Định tuyến lại thủ công",
      "other": "Khác",
      "quality_concern": "Vấn đề chất lượng",
      "vendor_downtime": "Vendor ngừng hoạt động"
    },
    "reassign": {
      "appliedDesc": "Đã phân công lại {{count}} đơn cho {{vendor}}.",
      "appliedTitle": "Đã áp dụng phân công lại hàng loạt",
      "applyFailedTitle": "Áp dụng thất bại",
      "applying": "Đang áp dụng…",
      "aria": "Phân công lại vendor hàng loạt",
      "cancel": "Hủy",
      "categoryLabel": "Nhóm lý do*",
      "cols": {
        "current": "Hiện tại",
        "error": "Lỗi",
        "orderId": "Mã đơn",
        "status": "Trạng thái"
      },
      "confirmApply": "Xác nhận áp dụng",
      "confirmApplyCount": "Xác nhận áp dụng ({{count}})",
      "description": "{{count}} đơn được chọn. Chỉ chuyển quyền sở hữu — không kích hoạt phê duyệt lại. Lý do tối thiểu {{min}} ký tự.",
      "newVendorFallback": "vendor mới",
      "preview": "Xem trước",
      "previewBatchId": "batchId: {{batchId}}…",
      "previewFailedTitle": "Xem trước thất bại",
      "previewInvalidVendor": "{{count}} vendor không hợp lệ",
      "previewOther": "{{count}} khác",
      "previewSkipStatus": "{{count}} bỏ qua do trạng thái",
      "previewValid": "{{count}} hợp lệ",
      "previewing": "Đang xem trước…",
      "reasonLabel": "Lý do* ({{current}}/{{min}}+ ký tự)",
      "reasonPlaceholder": "Giải trình chi tiết (nhật ký kiểm toán)…",
      "title": "Phân công lại Vendor hàng loạt",
      "vendorLabel": "Vendor mới*",
      "vendorPlaceholder": "Chọn vendor…",
      "hintNoVendor": "Các đơn đã chọn chưa có vendor để chuyển. Dùng “Assign Vendor” để gán vendor trước.",
      "hintNoValid": "Không có đơn nào đủ điều kiện chuyển vendor."
    },
    "savedViews": {
      "appliedTitle": "Đã áp dụng chế độ xem",
      "applyPlaceholder": "— Áp dụng chế độ xem đã lưu —",
      "archive": "Lưu trữ",
      "createdDesc": "\"{{name}}\" — khôi phục từ bộ lọc này.",
      "createdTitle": "Đã tạo chế độ xem",
      "deleteFailedTitle": "Xóa chế độ xem thất bại",
      "deleteLatest": "Xóa mới nhất",
      "deleteLatestTitle": "Xóa chế độ xem đã lưu gần nhất",
      "deletedTitle": "Đã xóa chế độ xem",
      "label": "Chế độ xem đã lưu",
      "saveCurrent": "Lưu hiện tại",
      "saveFailedTitle": "Lưu chế độ xem thất bại"
    },
    "archive": {
      "_comment": "Phase 3.3 Amendment #3 — Archive custom view (bucket=archive).",
      "badge": "Lưu trữ",
      "clear": "Thoát chế độ lưu trữ",
      "empty": "Không có đơn nào trong lưu trữ."
    },
    "toolbar": {
      "importTitle": "Import CSV — gán lại Vendor hàng loạt",
      "export": "Export",
      "exporting": "Đang xuất…",
      "searchPlaceholder": "Tìm theo mã đơn, email, tên sản phẩm, tracking…",
      "filterPending": "Filter này sẽ wire khi BE hỗ trợ",
      "productPlaceholder": "Sản phẩm",
      "refreshTitle": "Làm mới / xoá bộ lọc",
      "statusOptions": {
        "placeholder": "Trạng thái",
        "draft": "Nháp",
        "waiting": "Chờ phê duyệt",
        "assigned": "Đã phân công",
        "in_production": "Đang sản xuất",
        "ready_to_ship": "Sẵn sàng giao",
        "shipped": "Đã giao vận",
        "delivered": "Đã giao",
        "on_hold": "Tạm giữ",
        "cancelled": "Đã hủy"
      }
    },
    "sla": {
      "overdue": "Quá hạn",
      "dueInDays": "Còn {{days}} ngày",
      "dash": "—"
    },
    "assignModal": {
      "aria": "Gán vendor cho các đơn đã chọn",
      "title": "Gán Vendor",
      "description": "Gán vendor cho {{count}} đơn đã chọn.",
      "vendorLabel": "Vendor",
      "vendorPlaceholder": "Chọn vendor…",
      "cancel": "Huỷ",
      "confirm": "Gán vendor"
    }
  },
  "modals": {
    "addSurcharge": {
      "amountCentsHint": "Tương đương {{cents}} cents.",
      "amountError": "Số tiền phải lớn hơn 0 và tối đa 2 chữ số thập phân.",
      "amountLabel": "Số tiền (USD)",
      "amountPlaceholder": "Ví dụ: 12.50",
      "autoPayNotice": "Merchant đã bật tự động thanh toán — phụ phí sẽ được trừ vào ví tự động.",
      "cancel": "Hủy",
      "descDefault": "Thêm phụ phí cho đơn hàng này.",
      "descWithLabel": "Thêm phụ phí cho đơn {{label}}.",
      "enoughChars": "Đủ điều kiện",
      "errors": {
        "network": "Lỗi kết nối — vui lòng thử lại."
      },
      "needMoreChars": "Cần thêm {{count}} ký tự",
      "paymentCredit": "Công nợ (credit)",
      "paymentMethodLegend": "Phương thức thanh toán",
      "paymentWallet": "Ví (wallet)",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…",
      "submit": "Thêm phụ phí",
      "submitting": "Đang xử lý…",
      "title": "Thêm phụ phí"
    },
    "assign": {
      "blacklist": "Danh sách đen",
      "cancel": "Hủy",
      "capacityShort": "Công suất {{pct}}%",
      "costGuard": {
        "break_even": "hòa vốn",
        "loss": "lỗ",
        "profit": "có lãi"
      },
      "descAssign": "Chọn vendor xử lý đơn và ghi lý do để lưu vào nhật ký kiểm toán.",
      "descBulk": "Chọn 1 vendor sẽ áp dụng cho toàn bộ danh sách đã chọn. Đơn không đủ điều kiện sẽ rơi vào danh sách thất bại.",
      "descReassign": "Vendor hiện tại: {{vendor}}. Chọn vendor mới và ghi lý do.",
      "dualApprovalBanner": "Bulk > 5 đơn — cần phê duyệt kép (dual approval,) trước khi áp dụng.",
      "enoughChars": "Đủ điều kiện",
      "errors": {
        "network": "Lỗi kết nối — vui lòng kiểm tra kết nối",
        "suggestionsLoad": "Không tải được danh sách gợi ý vendor"
      },
      "needMoreChars": "Cần thêm {{count}} ký tự",
      "overrideScoreLabel": "Ghi đè gợi ý 5 yếu tố (override score)",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Tối thiểu {{min}} ký tự, để lưu nhật ký kiểm toán.",
      "scoreLabel": "Điểm {{score}}",
      "selectButton": "Chọn",
      "submitAssign": "Gán vendor",
      "submitBulk": "Gán cho {{count}} đơn",
      "submitReassign": "Chuyển vendor",
      "submitting": "Đang gán…",
      "suggestionsEmpty": "Không có vendor đủ điều kiện — nhập vendor thủ công bên dưới.",
      "suggestionsLoading": "Đang tải gợi ý…",
      "suggestionsTitle": "Gợi ý top 3 (công thức 5 yếu tố)",
      "titleAssign": "Gán vendor cho đơn (assign)",
      "titleBulk": "Gán vendor cho {{count}} đơn",
      "titleReassign": "Chuyển sang vendor khác (reassign)",
      "vendorIdError": "Vendor ID phải là chuỗi hex 24 ký tự.",
      "vendorIdLabel": "Vendor ID",
      "vendorIdPlaceholder": "ObjectId 24 ký tự (chọn từ gợi ý hoặc dán trực tiếp)",
      "whitelist": "Danh sách trắng"
    },
    "assignmentSimulation": {
      "adjustWeightsHint": "Điều chỉnh trọng số để tổng = 1.00 trước khi xem kết quả.",
      "allocationBranch": "Item này định tuyến theo tỷ lệ phân bổ nên lượt chọn bỏ qua giá và ưu tiên.",
      "applyButton": "Áp dụng với vendor đã chọn",
      "applyWord": "Áp dụng",
      "cancel": "Hủy",
      "costDesc": "Chi phí sản xuất item này, so với phần còn lại của pool.",
      "costLabel": "Chi phí",
      "descLead": "Mô phỏng what-if cho bảng điểm vendor. Kết quả",
      "descMid": "— chỉ ảnh hưởng khi bạn bấm",
      "descNot": "không được lưu",
      "descTail": "với vendor đã chọn.",
      "errors": {
        "network": "Lỗi kết nối — vui lòng thử lại.",
        "sumRejected": "Máy chủ từ chối bộ trọng số này: bốn trục phải cộng lại đúng 1.00 (nhận được {{sum}}).",
        "outOfRangeAxes": "Ngoài khoảng cho phép: {{axes}}"
      },
      "noVendorInPool": "Không có vendor nào trong pool đáp ứng.",
      "notPersistedHint": "Mô phỏng không lưu — chỉ ảnh hưởng tới hành động Apply tiếp theo.",
      "poolSize": "Số vendor mà lượt chọn sẽ lấy ra từ đó: {{size}}",
      "preferenceApplied": "Xếp hạng ưu tiên đã sắp lại các vendor bằng điểm ở nhóm dẫn đầu.",
      "ratingDesc": "Điểm chất lượng của vendor.",
      "ratingLabel": "Đánh giá",
      "recalculating": "Đang tính lại…",
      "resetButton": "Đặt lại về bộ trọng số đang chạy",
      "ruleContext": {
        "allowNarrowed": "Danh sách cho phép của merchant đã loại bớt vendor khỏi pool này.",
        "blocked": "Bị luật định tuyến của merchant chặn: {{value}}",
        "frozen": "Bị admin đóng băng ở location này: {{value}}",
        "fenced": "Nằm ngoài ràng buộc vị trí: {{value}}",
        "hardFilter": "Bị bộ lọc năng lực loại: {{value}}",
        "rejected": "Đã từng gán cho item này: {{value}}",
        "rulesReadFailed": "Không đọc được luật định tuyến của merchant nên item bị giữ lại thay vì định tuyến theo phỏng đoán. Đây là lỗi hệ thống, không phải luật do merchant đặt."
      },
      "slaDesc": "Mức đúng hạn so với thời hạn đã cam kết.",
      "slaLabel": "SLA",
      "sumWarningPrefix": "Tổng trọng số phải bằng 1.00. Hiện tại:",
      "title": "Mô phỏng gán vendor (what-if)",
      "tooltipAdjustFirst": "Điều chỉnh trọng số = 1.00 để chạy mô phỏng trước",
      "tooltipSelectVendor": "Chọn 1 vendor trong danh sách phía dưới để kích hoạt",
      "topVendorHeading": "Top vendor sau khi tính lại điểm",
      "utilizationDesc": "Phần công suất trong ngày của vendor còn trống.",
      "utilizationLabel": "Mức tải",
      "weightsHeading": "Trọng số (tổng = {{sum}})",
      "weightsLoading": "Đang đọc bộ trọng số đang chạy…",
      "weightsSource": {
        "live": "Trọng số đang chạy — đúng bộ mà router sẽ dùng cho item này ngay lúc này.",
        "override": "Bộ bạn tự chỉnh — chỉ để xem thử. Bộ trọng số đang chạy không đổi và không có gì được lưu."
      },
      "weightsVersion": "Bộ trọng số v{{version}}"
    },
    "refund": {
      "adminSuffix": " (admin)",
      "alreadyRefunded": "Đã hoàn",
      "ariaEstimatedRefund": "Số tiền hoàn ước tính cho {{label}}",
      "ariaRefundScope": "Phạm vi hoàn tiền",
      "backendPendingBody": "Không thể tạo yêu cầu hoàn tiền — module Phase 4 chưa được triển khai trong môi trường này, hoặc đơn không tồn tại. Bản ghi kiểm toán đã được lưu cục bộ.",
      "backendPendingTitle": "Backend chưa sẵn sàng",
      "bannerAwaitingMid": "đang",
      "bannerAwaitingPost": "chờ admin thứ hai phê duyệt.",
      "bannerAwaitingPre": "Hoàn tiền",
      "bannerPendingDesc": "Hoàn tiền lớn hơn $500 cần admin thứ hai phê duyệt.",
      "cancel": "Hủy",
      "charsUnit": "ký tự",
      "close": "Đóng",
      "description": "Phase 4 quản lý backend hoàn tiền. Modal này gửi yêu cầu tới dịch vụ chính thức; tiền sẽ được ghi có vào ví merchant khi hoàn tất.",
      "destinationPrefix": "Đích hoàn tiền:",
      "destinationSuffix": ". Không hỗ trợ đích đến nào khác trong bản này.",
      "destinationWallet": "ví merchant",
      "errors": {
        "noRefundable": "Đơn này không còn sản phẩm nào có thể hoàn.",
        "noteTooLong": "Ghi chú lý do phải ≤ {{max}} ký tự.",
        "otherRequiresNote": "Lý do \"Khác\" cần ghi chú giải thích việc hoàn tiền.",
        "qtyExceeds": "Số lượng cho \"{{label}}\" vượt quá số có thể hoàn ({{max}}).",
        "qtyInteger": "Số lượng cho \"{{label}}\" phải là số nguyên không âm.",
        "requestFailed": "Yêu cầu hoàn tiền thất bại — vui lòng thử lại.",
        "selectOne": "Chọn ít nhất 1 sản phẩm với số lượng > 0."
      },
      "estimatedTotal": "Tổng ước tính",
      "gatewayDefault": "Stripe (mặc định)",
      "lineItems": "Sản phẩm",
      "lineItemsFull": "(đã chọn sẵn toàn bộ số lượng)",
      "lineItemsPartial": "(nhập số lượng cần hoàn)",
      "maxQty": "(tối đa {{max}})",
      "maxRefundable": "Tối đa có thể hoàn",
      "originalGateway": "Cổng thanh toán gốc",
      "queuedFor": "với số tiền",
      "queuedIs": "đang",
      "queuedPre": "Hoàn tiền",
      "queuedTitle": "Đã đưa hoàn tiền vào hàng đợi",
      "queuedTo": "chuyển vào ví merchant.",
      "reasonCodes": {
        "CHANGED_MIND": "Khách đổi ý",
        "CUSTOMER_REQUEST": "Khách yêu cầu (thiện chí)",
        "DUPLICATE_ORDER": "Đơn trùng lặp",
        "FRAUD_SUSPECTED": "Nghi ngờ gian lận",
        "OTHER": "Khác (ghi rõ trong ghi chú)",
        "POLICY_VIOLATION": "Vi phạm chính sách",
        "SYSTEM_ERROR": "Lỗi hệ thống",
        "VENDOR_FAILURE": "Lỗi do vendor",
        "WRONG_ADDRESS": "Sai địa chỉ giao hàng",
        "WRONG_ARTWORK": "Sai thiết kế in",
        "WRONG_PRODUCT": "Giao sai sản phẩm"
      },
      "reasonLabel": "Lý do",
      "reasonNoteLabel": "Ghi chú lý do (tùy chọn, ≤ {{max}} ký tự)",
      "reasonNotePlaceholder": "Giải thích bối cảnh hoàn tiền để lưu nhật ký kiểm toán…",
      "serverComputed": "(số cuối do máy chủ tính)",
      "submitRefund": "Hoàn {{amount}}",
      "submitRequest": "Yêu cầu hoàn tiền ({{amount}})",
      "submitting": "Đang gửi…",
      "tabFull": "Hoàn toàn bộ",
      "tabPartial": "Hoàn một phần",
      "title": "Hoàn tiền đơn — {{order}}",
      "toastAwaitingDesc": "Hoàn tiền > $500 cần admin thứ hai ký duyệt.",
      "toastAwaitingTitle": "Chờ phê duyệt từ admin khác",
      "toastBackendDesc": "Không thể xử lý hoàn tiền — dịch vụ Phase 4 chưa được triển khai hoặc đơn không tồn tại.",
      "toastBackendTitle": "Backend chưa sẵn sàng",
      "toastFailedTitle": "Hoàn tiền thất bại",
      "toastProcessingDesc": "{{order}} — {{amount}} đã được đưa vào hàng đợi chuyển tới ví merchant.",
      "toastProcessingTitle": "Đang xử lý hoàn tiền"
    },
    "resend": {
      "close": "Đóng",
      "costLabels": {
        "platform": "Platform chịu hoàn toàn (0% vendor / 100% platform)",
        "shared": "Chia 50/50 (50% vendor / 50% platform)",
        "vendor": "Vendor chịu hoàn toàn (100% vendor / 0% platform)"
      },
      "costLegend": "Cost responsibility (ai chịu chi phí)",
      "costNotice": "Merchant không bị trừ ví (resend không charge merchant) — chi phí chia giữa vendor và platform.",
      "descDefault": "Tạo đơn mới được liên kết với đơn gốc. Merchant không bị tính phí — chi phí chia theo cost-responsibility.",
      "descWithNumberPost": ". Merchant không bị tính phí (resend không trừ ví merchant — chi phí được phân chia theo cost-responsibility).",
      "descWithNumberPre": "Tạo đơn mới được liên kết với đơn gốc",
      "enoughChars": "Đủ điều kiện",
      "errors": {
        "network": "Lỗi kết nối — vui lòng kiểm tra kết nối"
      },
      "itemsLegend": "Sản phẩm cần in lại",
      "itemsRequired": "Cần chọn ít nhất 1 sản phẩm",
      "needMoreChars": "Cần thêm {{count}} ký tự",
      "newVendorError": "Vendor id phải là ObjectId hex 24 ký tự",
      "newVendorPlaceholder": "ví dụ: 64f0c1a2b3c4d5e6f7a8b9c0",
      "noVendor": "Đơn chưa có vendor",
      "previewLabel": "Vendor đích preview:",
      "previewNewEmpty": "(chưa nhập vendor mới)",
      "previewNoVendor": "— (đơn chưa có vendor)",
      "previewSameId": "{{id}}… (giữ nguyên vendor cũ)",
      "previewSameNamed": "{{name}} (giữ nguyên vendor cũ)",
      "reasonLabel": "Lý do gửi lại",
      "reasonPlaceholder": "Nhập lý do (tối thiểu {{min}} ký tự)…",
      "submit": "Tạo đơn gửi lại",
      "submitting": "Đang tạo đơn mới…",
      "targetLegend": "Vendor đích khi gửi lại",
      "targetNew": "Chuyển sang vendor mới",
      "targetNewHint": "Nhập vendor id (ObjectId hex 24 ký tự)",
      "targetSame": "Cùng vendor (giữ nguyên)",
      "title": "Gửi lại đơn hàng (in lại)"
    }
  },
  "pendingAssign": {
    "actions": {
      "assign": "Gán thủ công",
      "assignFailDefault": "Gán thủ công thất bại.",
      "cancel": "Huỷ",
      "escalate": "Báo cáo escalate",
      "escalateFail": "Có {{fail}} đơn không escalate được.",
      "partialResult": "Gán {{success}}/{{total}} đơn. {{fail}} đơn lỗi — xem chi tiết bên dưới.",
      "reasonLabel": "Lý do",
      "reasonPlaceholder": "Ghi lại lý do gán thủ công để audit log",
      "requiredFields": "Vui lòng nhập đầy đủ Vendor ID, tên vendor, và lý do gán thủ công.",
      "resultSuccess": "thành công",
      "resultUnknownError": "lỗi không xác định",
      "selectedPrefix": "Đã chọn",
      "selectedSuffix": "đơn",
      "skip": "Bỏ qua",
      "submit": "Gửi",
      "submitting": "Đang xử lý…",
      "vendorIdLabel": "Vendor ID",
      "vendorIdPlaceholder": "ObjectId 24-hex",
      "vendorNameLabel": "Tên vendor",
      "vendorNamePlaceholder": "VD: PrintCo VN",
      "escalateReason": "Admin yêu cầu escalate sớm (manual override)"
    },
    "page": {
      "autoRefresh": "Tự động làm mới mỗi 30 giây.",
      "columns": {
        "escalated": "Đã escalate",
        "items": "Items",
        "orderId": "Order ID",
        "received": "Tiếp nhận",
        "slaRemaining": "SLA còn lại",
        "status": "Trạng thái",
        "tier": "Mức cảnh báo"
      },
      "description": "Hàng đợi đơn không tự gán được vendor. SLA 2 giờ — quá hạn sẽ tự động báo lên Super Admin.",
      "empty": "Không có đơn nào đang chờ gán thủ công.",
      "escalatedYes": "Có",
      "heading": "Chờ gán thủ công",
      "loadError": "Không tải được hàng đợi Pending Manual Assign.",
      "loading": "Đang tải hàng đợi…",
      "selectAll": "Chọn tất cả",
      "selectRow": "Chọn đơn {{orderId}}",
      "tiers": {
        "T1": "Cảnh báo (1h-2h)",
        "T2": "Quá hạn (2h-4h)",
        "T3": "Khẩn cấp (>4h)",
        "none": "Trong hạn"
      }
    }
  },
  "refundPanel": {
    "awaitingApproval": "Chờ phê duyệt kép.",
    "backendPending": "Hoàn tiền sẽ hiển thị tại đây sau khi module Phase 4 triển khai.",
    "defaultTitle": "Lịch sử hoàn tiền",
    "empty": "Chưa có khoản hoàn tiền nào cho đơn này.",
    "errorFallback": "Không tải được lịch sử hoàn tiền.",
    "loading": "Đang tải hoàn tiền…",
    "refreshing": "Đang làm mới…",
    "statusLabels": {
      "approved": "Đã duyệt",
      "failed": "Thất bại",
      "pending": "Chờ xử lý",
      "processed": "Đã xử lý",
      "rejected": "Bị từ chối"
    }
  },
  "rightColumn": {
    "financialSummary": {
      "cogs": "COGS (giá vốn)",
      "costGatedBadge": "giới hạn theo chi phí",
      "margin": "Lợi nhuận",
      "naValue": "N/A",
      "payoutsPending": "Chờ chi trả",
      "perItemRow": "{{item}} · nhà cung cấp {{vendor}}",
      "perItemSummary": "Chi phí vendor theo từng item ({{count}})",
      "revenue": "Doanh thu",
      "title": "Tóm tắt tài chính"
    },
    "merchantInfo": {
      "customer": "Khách hàng",
      "email": "Email",
      "phone": "Điện thoại",
      "title": "Merchant"
    },
    "paymentInfo": {
      "grandTotal": "Tổng đơn",
      "placeholderHint": "Liên kết giao dịch sẽ hiển thị khi Phase 8.2 deploy.",
      "title": "Thanh toán",
      "viewTransaction": "Xem giao dịch →"
    },
    "statusActions": {
      "actions": {
        "assign": "Gán / Gán lại",
        "cancel": "Hủy đơn",
        "refund": "Hoàn tiền",
        "resend": "Gửi lại",
        "surcharge": "Thêm phụ phí"
      },
      "statusLabels": {
        "accepted": "Đã chấp nhận",
        "assigned": "Đã gán",
        "cancelled": "Đã hủy",
        "confirmed": "Đã xác nhận",
        "delivered": "Đã giao",
        "draft": "Nháp",
        "in_production": "Đang sản xuất",
        "on_hold": "Tạm giữ",
        "pending_emb_payment": "Chờ thanh toán EMB",
        "pending_payment": "Chờ thanh toán",
        "pending_reassignment": "Chờ gán lại",
        "returned": "Đã trả hàng",
        "shipped": "Đã gửi hàng"
      },
      "title": "Trạng thái"
    },
    "vendorScore": {
      "alternatives": "Phương án khác (top {{count}})",
      "assignedBadge": "Đang gán",
      "contributionNote": "Giá trị bên phải dấu = là đóng góp đã nhân trọng số (weighted contribution). Tổng các đóng góp = total score.",
      "costAxisLabel": "Trục chi phí đã chuẩn hoá (0–1) và chi phí sản xuất của vendor cho đơn này.",
      "costNotDeclared": "Chưa khai báo chi phí",
      "errorNetwork": "Lỗi mạng - kiểm tra kết nối",
      "factors": {
        "cost": "Chi phí",
        "rating": "Đánh giá",
        "sla": "SLA",
        "utilization": "Mức tải"
      },
      "formulaBodyV3": " — điểm = đánh giá × {{rating}} + mức tải × {{utilization}} + SLA × {{sla}} + chi phí × {{cost}}.",
      "formulaLink": "{{version}} (§6.13 Quy tắc gán đơn)",
      "formulaPrefix": "Công thức",
      "heading": "Phân tích chấm điểm vendor",
      "legacyBadge": "Bản cũ",
      "legacyExplain": "Đơn này được chấm điểm trước khi có trục chi phí, nên hệ thống không lưu chi phí nào cho nó.",
      "loading": "Đang tải phân tích…",
      "noScored": "Chưa có vendor nào được chấm điểm cho đơn hàng này.",
      "rerunButton": "Chấm điểm lại (thử trọng số — không lưu)",
      "retry": "Thử lại",
      "totalLabel": "Tổng",
      "weightsProvenance": "Bộ trọng số có hiệu lực lúc gán đơn này — không phải bộ đang dùng hôm nay.",
      "weightsVersion": "Bộ trọng số v{{version}}",
      "weightsVersionUnknown": "Bộ trọng số: không có bản ghi",
      "weightsVersionFallback": "bộ mặc định — không đọc được bộ trọng số đã duyệt",
      "multiItemNotice": "Đây là giải thích cho một item trong {{count}} item của đơn. Mỗi item được định tuyến riêng trên pool vendor riêng, nên điểm của các item khác nhau không so sánh được với nhau.",
      "unknownVendor": "Vendor không còn tồn tại"
    },
    "vendors": {
      "empty": "Chưa có vendor được gán.",
      "itemCount_one": "{{count}} sản phẩm",
      "itemCount_other": "{{count}} sản phẩm",
      "title": "Nhà cung cấp",
      "vendorFallback": "Vendor #{{id}}"
    },
    "production": {
      "stateLabels": {
        "in_production": "Đang sản xuất",
        "quality_check": "Kiểm tra chất lượng",
        "ready_to_ship": "Sẵn sàng giao"
      },
      "vendorUnassigned": "Chưa gán vendor",
      "empty": "Chưa có item nào đang trong sản xuất."
    },
    "salesPerson": {
      "unassigned": "Chưa gán",
      "attributionPending": "Attribution — chờ backend (Task 53 / D-494)."
    },
    "vendorPushAlerts": {
      "stuckPre": "Đơn kẹt ở",
      "stuckPost": "{{days}} ngày (ngưỡng {{threshold}} ngày).",
      "rejectPre": "Vendor đẩy",
      "rejectPost": "bị từ chối",
      "missingFields": "— thiếu: {{fields}}"
    }
  },
  "settings": {
    "policyStub": "SLA & chính sách đơn hàng — sắp có.",
    "tabs": {
      "bulk": "Công cụ hàng loạt",
      "policy": "Chính sách"
    }
  },
  "paymentStatusLabels": {
    "paid": "Đã thanh toán",
    "partial": "Thanh toán một phần",
    "pending": "Chờ xử lý",
    "refunded": "Đã hoàn tiền",
    "unpaid": "Chưa thanh toán"
  },
  "sourceLabels": {
    "api": "API",
    "etsy_import": "Etsy",
    "manual_admin": "Admin tạo",
    "merchant_dashboard": "Merchant tạo",
    "other": "Khác",
    "partner_api": "API đối tác",
    "shopify_import": "Shopify",
    "tiktok_import": "TikTok"
  },
  "statusLabels": {
    "accepted": "Đã tiếp nhận",
    "assigned": "Đã phân công",
    "attention_required": "Cần chú ý",
    "cancelled": "Đã hủy",
    "confirmed": "Đã xác nhận",
    "delivered": "Đã giao",
    "draft": "Nháp",
    "in_production": "Đang sản xuất",
    "on_hold": "Tạm giữ",
    "partially_cancelled": "Hủy một phần",
    "partially_shipped": "Giao vận một phần",
    "pending_emb_payment": "Chờ thanh toán thêu",
    "pending_payment": "Chờ thanh toán",
    "pending_reassignment": "Chờ phân công lại",
    "quality_check": "Kiểm tra chất lượng",
    "ready_to_ship": "Sẵn sàng giao",
    "returned_partial": "Trả hàng một phần",
    "shipped": "Đã giao vận",
    "unknown": "Không rõ"
  },
  "tabs": {
    "aria": "Tab đơn hàng",
    "descriptions": {
      "all": "Tất cả đơn hàng của mọi merchant.",
      "cancelled": "Đã hủy hoặc hủy một phần (chuyển tiếp).",
      "delivered": "Đã giao cho khách.",
      "draft_unpaid": "Đơn nháp và đơn chờ thanh toán.",
      "issues": "Tạm giữ / gán lại / trả một phần — bộ lọc phụ chip.",
      "pending": "Đã xác nhận / đã gán / vendor đã nhận.",
      "pending_manual_assign": "bộ tự gán không chọn được; admin phải chọn vendor thủ công.",
      "processing": "Đang sản xuất / kiểm tra chất lượng / sẵn sàng gửi.",
      "resent": "Sản phẩm đã được in lại (chuyển tiếp).",
      "shipped": "Đã gửi (toàn bộ hoặc một phần).",
      "unassigned": "Đơn đã xác nhận, đang chờ gán vendor."
    },
    "labels": {
      "all": "Tất cả",
      "cancelled": "Đã hủy",
      "delivered": "Đã giao",
      "draft_unpaid": "Nháp / Chưa thanh toán",
      "issues": "Sự cố",
      "pending": "Đang chờ",
      "pending_manual_assign": "Chờ gán thủ công",
      "processing": "Đang xử lý",
      "resent": "In lại",
      "shipped": "Đã gửi",
      "unassigned": "Chưa gán"
    }
  },
  "timeline": {
    "aria": "Trạng thái đơn hàng",
    "cancelledBanner": "Đơn đã hủy / hoàn — vòng đời xử lý không còn áp dụng.",
    "statusLabels": {
      "approval": "Duyệt",
      "delivered": "Đã giao",
      "new": "Mới",
      "production": "Đang sản xuất",
      "shipped": "Đã gửi",
      "assigned": "Đã gán",
      "accepted": "Đã nhận",
      "quality_check": "Kiểm tra CL",
      "ready_to_ship": "Sẵn sàng giao"
    },
    "issuePrefix": "Cần xử lý — ",
    "issueLabels": {
      "error-artwork": "Lỗi artwork",
      "unverified": "Địa chỉ chưa xác minh",
      "on_hold": "Tạm giữ",
      "attention_required": "Cần chú ý",
      "pending_reassignment": "Chờ gán lại",
      "unknown": "Trạng thái không rõ"
    }
  },
  "vendorOverride": {
    "cancel": "Hủy",
    "categoryLabel": "Reason category*",
    "hint": "Override vendor cho đơn này. Reason ≥ {{min}} ký tự + chọn category. KHÔNG re-approve.",
    "reasonCategories": {
      "capacity_overflow": "Quá tải công suất",
      "manual_reroute": "Định tuyến lại thủ công",
      "other": "Khác",
      "quality_concern": "Lo ngại chất lượng",
      "vendor_downtime": "Vendor ngừng hoạt động"
    },
    "reasonCounter": "{{current}} / {{min}} ký tự tối thiểu",
    "reasonLabel": "Reason (≥ {{min}} ký tự)*",
    "submit": "Override vendor",
    "submitting": "Đang override…",
    "title": "Sửa vendor (override đơn lẻ)",
    "toast": {
      "errorDefault": "Override vendor thất bại",
      "errorInvalidCategory": "Reason category không hợp lệ",
      "errorNoVendor": "Đơn chưa có vendor — dùng Assign vendor thay vì Override",
      "errorNoop": "Vendor mới trùng vendor hiện tại",
      "errorReasonTooShort": "Reason phải tối thiểu {{min}} ký tự",
      "errorStatusLocked": "Đơn đã chuyển sang vận chuyển",
      "successDesc": "Vendor mới đã được gán cho đơn (KHÔNG re-approve).",
      "successTitle": "Đã override vendor"
    },
    "vendorLabel": "Vendor mới*",
    "vendorPlaceholder": "Chọn vendor…"
  },
  "common": {
    "close": "Đóng"
  },
  "orderType": {
    "BASIC": "Cơ bản",
    "SAMPLE": "Mẫu",
    "BULK_FBA_FBT": "Số lượng lớn (FBA/FBT)",
    "BUNDLE": "Combo"
  },
  "artworkLabels": {
    "ok": "Có artwork",
    "missing": "Thiếu artwork"
  },
  "promoBanner": {
    "title": "Mua càng nhiều, tiết kiệm càng lớn với chiết khấu số lượng!",
    "subtitle": "Đặt từ 10+ sản phẩm và nhận đến 15% giảm giá phí vận chuyển & sản phẩm.",
    "itemsOrdered": "Số lượng đặt",
    "itemsOrderedValue": "10+ sản phẩm",
    "shippingDiscount": "Chiết khấu vận chuyển",
    "shippingDiscountValue": "Đến 10%",
    "productDiscount": "Chiết khấu sản phẩm",
    "productDiscountValue": "Đến 5%",
    "learnMore": "Tìm hiểu thêm",
    "goToSettings": "Đến cài đặt",
    "settings": {
      "routing": "Định tuyến:",
      "disabled": "Đã tắt",
      "approval": "Phê duyệt:",
      "automatic": "Tự động",
      "trackingNotifications": "Thông báo vận đơn:",
      "delayedOrders": "Đơn trễ hạn:",
      "manual": "Thủ công"
    }
  },
  "inlineVendor": {
    "assign": "Gán",
    "reassign": "Đổi vendor",
    "assignedFallback": "Đã gán",
    "unpaidTooltip": "Chỉ gán được vendor sau khi item đã thanh toán",
    "toast": {
      "successTitle": "Đã cập nhật vendor",
      "errorDefault": "Không cập nhật được vendor",
      "errorUnpaid": "Item chưa thanh toán — cần thanh toán trước",
      "errorConflict": "Item vừa thay đổi ở tab khác — tải lại rồi thử lại",
      "errorNoop": "Đây đã là vendor hiện tại",
      "errorLocked": "Không thể đổi vendor ở trạng thái đơn này",
      "errorNoVendor": "Item chưa có vendor — hãy gán trước"
    },
    "dialog": {
      "assignTitle": "Gán vendor cho item",
      "reassignTitle": "Đổi vendor của item",
      "vendorPlaceholder": "Tìm vendor…",
      "reasonCategoryLabel": "Nhóm lý do",
      "reasonLabel": "Lý do (tối thiểu {min} ký tự)",
      "reasonPlaceholder": "Vì sao gán vendor này?",
      "cancel": "Huỷ",
      "confirm": "Xác nhận",
      "saving": "Đang lưu…"
    },
    "reasonCategories": {
      "capacity_overflow": "Quá tải công suất",
      "vendor_downtime": "Vendor ngừng hoạt động",
      "manual_reroute": "Định tuyến thủ công",
      "quality_concern": "Vấn đề chất lượng",
      "other": "Khác"
    }
  },
  "_vgBinding": "vg-binding: P8.1.1.D-15 — i18n keys cho cột mới của danh sách đơn (product/platform/orderType/merchantEmail/sla), nhãn ô SLA, nhãn enum loại đơn + artwork (giá trị giữ tiếng Anh), và nhãn filter store/payment/artwork/product cho en/vi/fr [task-11]",
  "capabilityReasons": {
    "canRefund": {
      "preAssign": "Đơn chưa thanh toán — không có giao dịch để hoàn",
      "terminal": "Đơn đã ở trạng thái cuối — không thể hoàn tiền"
    },
    "canCancel": {
      "terminal": "Đơn đã ở trạng thái cuối",
      "shipped": "Đơn đã giao cho hãng vận chuyển — không hủy được"
    },
    "canResend": "Chỉ resend khi đơn đã giao xong hoặc bị trả về (return-to-sender)",
    "canReassign": "Đơn đã gửi cho hãng vận chuyển hoặc đã ở trạng thái cuối — không đổi được vendor",
    "canEscalate": "Đơn đã ở trạng thái cuối — không cần escalate",
    "canReassignPreAssign": "Đơn chưa thanh toán — chưa thể gán vendor"
  },
  "reasons": {
    "BLOCKED_BY_MERCHANT_RULE": "Luật định tuyến riêng của merchant không chừa lại vendor nào đủ điều kiện nên item đang chờ gán tay.",
    "MERCHANT_RULES_UNAVAILABLE": "Không đọc được luật định tuyến của merchant nên item bị giữ lại thay vì định tuyến theo phỏng đoán. Đây là lỗi hệ thống, không phải luật do merchant đặt — hãy kiểm tra service trước khi sửa bất kỳ luật nào.",
    "NO_VENDOR_FOR_LOCATION": "Không vendor nào được ràng buộc với vị trí này cho variant này nên item đang chờ gán tay.",
    "NO_VENDOR_MATCH": "Không có vendor nào khớp với item này nên item đang chờ gán tay.",
    "VENDOR_LOCATION_FROZEN": "Mọi xưởng ở location này đang bị admin đóng băng nên item phải chờ gán tay. Bỏ đóng băng ở tab Locations của xưởng, hoặc gán tay."
  }
}
